<!-- prettier-ignore -->
<div>
  @if (isMobile()) {
    <div class="card" role="status" aria-live="polite">
      <div class="frame" role="group" aria-labelledby="mobile-title">
        <p id="mobile-title" class="message">
          お使いのブラウザの画面サイズが小さいため、正しく表示できません。
        </p>
        <p class="message">次のいずれかをお試しください。</p>

        <ul class="points" aria-label="推奨される対処方法">
          <li><span>ブラウザの画面を最大化する</span></li>
          <li><span>ブラウザのズーム設定を縮小する</span></li>
          <li><span>より大きなディスプレイを使用する</span></li>
        </ul>
      </div>
    </div>
  } @else if (isFacadeError()) {
    <app-top-bar [title]="topBarTitle" [items]="topBarItems" ></app-top-bar>
    <app-skeleton
      type="alert"
      [messages]="['職員情報の取得に失敗しました。', 'しばらくしてから再度お試しください。']"
    />
  } @else {
    <app-top-bar [title]="topBarTitle" [items]="topBarItems"></app-top-bar>
    <router-outlet />
  }
</div>
